import { Component } from 'react';
import { locationShape } from 'react-router';
import { connect } from 'react-redux';
import { isEmpty, get } from 'lodash';
import { getAuthCredentials } from 'common/util/auth-storage';
import { replace } from 'react-router-redux';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { clearLoginStatus } from 'common/actions/login';
import { onGoingDocumentConversionCountSelector } from 'pages/files/selectors';
import { getGlobalEventEmitter } from 'common/util/GlobalEventDistributor';

class RestrictedContainer extends Component {
    checkMe() {
        const { me, replace } = this.props;

        if(isEmpty(me) && !getAuthCredentials()) {
            replace('/');
        }
    }

    showLastLogin(lastLoginDate) {
        const { addApplicationMessage } = this.props;
        addApplicationMessage('login', lastLoginDate, { ttl: 15000 });
    }

    componentDidMount() {
        this.checkMe();
        this.registerLeaveHook();
        const { clearLoginStatus, loginStatus } = this.props;

        if(loginStatus && !isEmpty(this.props.me.lastLogin)){
            this.showLastLogin(this.props.me.lastLogin);
            clearLoginStatus();
        }
    }

    componentWillUnmount() {
        this.unregisterHook();
    }

    registerLeaveHook() {
        const { route, router} = this.props;
        this.unregisterLeaveHook = router.setRouteLeaveHook(route, this.getDocumentConversionStatus.bind(this));
    }

    unregisterHook() {
        this.unregisterLeaveHook();
    }

    getDocumentConversionStatus(location) {
        const { onGoingConversionCount } = this.props;
        const path = location.pathname;
        if(path === '/logout' && onGoingConversionCount > 0) {
            this.sendActiveConversionInteruptWarning();
            return false;
        }
    }

    sendActiveConversionInteruptWarning() {
        const globalEventDistributor = getGlobalEventEmitter();
        globalEventDistributor.emit('ActiveConversionInteruptWarning');
    }

    render() {
        return this.props.children;
    }
}

RestrictedContainer.contextTypes = {
    location: locationShape
};

export default connect((state) => {
    const originUrl = get(state, 'application.config.corsOriginUrl', null);
    const onGoingConversionCount = onGoingDocumentConversionCountSelector(state);
    return {
        me: state.me,
        loginStatus: state.app.loginStatus,
        indexRoute: `${originUrl}/`,
        onGoingConversionCount,
    };
}, {
    replace,
    addApplicationMessage,
    clearLoginStatus
})(RestrictedContainer);
